import { X } from "lucide-react";

/**
 * Full-screen overview modal — thumbnail grid of every slide. Triggered by Esc
 * or the sidebar "Overview" button. Clicking a thumb jumps to that slide.
 */
export function DeckOverview({ titles, total, idx, onClose, onJump }) {
  return (
    <div className="absolute inset-0 z-40 bg-cream-50/95 backdrop-blur-sm overflow-y-auto p-6 md:p-12 grain" data-testid="overview-panel">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.22em] text-sun-700">Overview</div>
          <div className="serif text-3xl mt-1">All slides · {total}</div>
        </div>
        <button
          onClick={onClose}
          data-testid="overview-close"
          className="flex items-center gap-2 mono text-[10px] uppercase tracking-[0.22em] text-ink-900/65 hover:text-sun-700"
        >
          Close <X className="h-3.5 w-3.5" />
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {titles.map((s) => (
          <button
            key={s.i}
            onClick={() => onJump(s.i)}
            data-testid={`overview-thumb-${s.i}`}
            className={`group text-left rounded-md border ${s.i === idx ? "border-sun-500" : "border-ink-900/10"} hover:border-sun-500 transition-colors p-5 bg-white/55`}
          >
            <div className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/55">
              {String(s.i + 1).padStart(2, "0")} · {s.group}
            </div>
            <div className="serif text-xl mt-2 text-ink-900 group-hover:text-sun-700 transition-colors">{s.t}</div>
          </button>
        ))}
      </div>
      <p className="mono text-[10px] uppercase tracking-[0.22em] text-ink-900/45 mt-10">
        Keyboard: ← → arrows · Space · Esc overview · F fullscreen
      </p>
    </div>
  );
}
